import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { FragmentMessages } from "../../common/fragment-messages";
import FootballState from "../state/football-state";
import ContinuedByDefaultValue from "./default-value/continued-by-default-value";

export default class Continued extends Fragment {
    constructor(continuedBy, continuedTo) {
        super();

        this.continuedBy = continuedBy;
        this.continuedTo = continuedTo;

        this.requiredData = [
            {
                name: "continuedBy",
                type: FragmentDataType.Player,
                displayName: "Continued By",
                title: (team) => `Continued By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true,
                defaultValue: ({ play, summaryContext }) =>
                    new ContinuedByDefaultValue(
                        play,
                        this,
                        summaryContext
                    ).resolve()
            },
            {
                name: "continuedTo",
                type: FragmentDataType.FieldPosition,
                displayName: "Continued To",
                title: "Continued To",
                subtitle: `Enter where the ball was recovered. ${FragmentMessages.FB_TEAM_FIELD_POSITION}`,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    getFieldPosition() {
        return this.continuedTo;
    }

    getPlayers() {
        return [this.continuedBy];
    }

    summarize(summaryContext, stringifier, play) {
        const isOnSideKickPlay =
            play.getPreceedingFragment(this, FootballState.OnSide)
                ?.associatedState === FootballState.OnSide;

        const messages = [
            `to ${stringifier.niceFieldPosition(
                summaryContext.gameConfig.general.fieldLength,
                summaryContext.fieldPosition,
                summaryContext.homeTeam?.abbrName,
                summaryContext.awayTeam?.abbrName
            )},`
        ];

        if (isOnSideKickPlay) {
            messages.push("returned");
        } else {
            messages.push("continued");
        }

        messages.push(
            `by ${stringifier.firstInitial(
                this.continuedBy
            )} for ${stringifier.gain(
                Object.assign(summaryContext, {
                    homeTeamHasPossession:
                        this?.continuedBy?.teamId === summaryContext.homeTeamId
                }),
                summaryContext.fieldPosition,
                this.continuedTo
            )}`
        );

        return new FragmentSummary(messages.join(" "));
    }

    updateSummaryContext(summaryContext) {
        summaryContext.fieldPosition = this.continuedTo;
        summaryContext.playerInPossession = this.continuedBy;
    }

    getFragmentTeamId() {
        return this.continuedBy?.teamId;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            continuedBy: playerReducer(this.continuedBy)
        };
    }
}
